import { CloseCircleFilled } from '@ant-design/icons'
import { DatePicker } from 'antd'
import { useTranslation } from 'src/utils/i18n'

const { RangePicker } = DatePicker

const RangePickerBox = ({ className, rangePickerClassName, onClear, ...props }) => {
  const { t } = useTranslation('common')

  return (
    <div className={'relative max-w-[400px] ' + (className || '')}>
      <RangePicker
        placeholder={[t('Start date'), t('End date')]}
        allowClear={false}
        picker='date'
        inputReadOnly={true}
        format='YYYY-MM-DD'
        className={'h-[40px] text-[16px] w-full max-w-[400px] ' + (rangePickerClassName || '')}
        {...props}
      ></RangePicker>
      {/* 日历 suffix 约占右侧 12–14px，清空按钮放其左侧，避免重叠 */}
      <CloseCircleFilled
        className='text-[#D9D9D9] absolute z-[1] translate-y-[-50%] right-[36px] top-[50%] cursor-pointer hover:text-[#bfbfbf]'
        onClick={e => {
          e.stopPropagation()
          onClear?.(e)
        }}
      />
    </div>
  )
}

export default RangePickerBox
